import {
  SALE_EXTENSION_SUBTEXT_SHORT,
  SALE_TITLE,
} from "@musicfy/contants/Sale";
import { PriceId, type TPriceId } from "@musicfy/contants/Subscriptions";

/**
 * In-app promo popup config (MemorialDayBanner).
 *
 * To run a new promo: update this object and ensure the Paddle discount exists
 * for `promoCode`. Change `dismissCookie` (e.g. hasDimissedPromoPopup_fall2026)
 * when you want eligible users to see the new campaign once despite prior dismissals.
 */
export const PROMO_POPUP = {
  enabled: false,
  /** Delay after eligibility before opening (client guidance: 30s–2min). */
  showDelayMs: 60_000,
  dismissCookie: "hasDimissedPromoPopup",
  dismissCookieDays: 7,
  title: SALE_TITLE,
  titleSubtext: SALE_EXTENSION_SUBTEXT_SHORT,
  headline: "60% off forever — and 1,000 people get six months free",
  supportText: "Upgrade today to unlock",
  cta: "Claim Your Spot + 6 Months Free",
  priceId: PriceId.pro_year as TPriceId,
  /** null = checkout with no code; set to e.g. "WELCOME50" to apply at open */
  promoCode: "WELCOME50" as string | null,
  origin: "promo-popup",
} as const;
